// TUAS — Per-size shipping labels (standalone)
// Built for the current Prestige theme. Reads the per-size map injected by
// theme.liquid (<script data-ship-labels>) and writes a shipping line on each
// size row inside the dropdown popover (.popover__value-option).
// Self-contained: no dependency on any other custom file.
(function () {
  var STYLE_ID = 'tuas-ship-style';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '.popover__value-list .popover__value-option{display:flex;align-items:center;}' +
      '.tuas-ship-label{margin-left:auto;padding-left:1rem;font-size:0.75rem;' +
      'letter-spacing:0.02em;color:#8a857c;white-space:nowrap;}';
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function readMap() {
    var el = document.querySelector('script[data-ship-labels]');
    if (!el) return {};
    try {
      var raw = JSON.parse((el.textContent || '').trim());
      var map = {};
      Object.keys(raw).forEach(function (k) {
        map[String(k).trim()] = raw[k];
      });
      return map;
    } catch (e) {
      return {};
    }
  }

  function sizeOf(option) {
    var spans = Array.prototype.slice.call(option.querySelectorAll('span'));
    var span = spans.find(function (s) {
      return !s.classList.contains('tuas-ship-label') && s.textContent.trim() !== '';
    });
    return ((span && span.textContent) || option.textContent || '').trim();
  }

  function apply() {
    var map = readMap();
    if (!Object.keys(map).length) return;

    var options = document.querySelectorAll('.popover__value-list .popover__value-option');
    if (!options.length) return;

    options.forEach(function (option) {
      var size = sizeOf(option);
      if (!size) return;

      var desired = map[size];
      if (!desired) return;

      var span = option.querySelector('.tuas-ship-label');
      if (!span) {
        span = document.createElement('span');
        span.className = 'tuas-ship-label';
        option.appendChild(span);
      }
      if (span.textContent !== desired) {
        span.textContent = desired;
      }
    });
  }

  function init() {
    injectStyles();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Prestige re-renders the variant picker on variant change — keep labels in sync.
  var mo = new MutationObserver(function () { apply(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
